import { LoadingButton } from "@mui/lab";
import { alpha, Stack, useTheme } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import useLocales from "src/hooks/useLocales";

import Context from "./context";

const sx = {
	borderRight: 0.5,
	borderTop: 0.5,
	flexDirection: "row",
	alignItems: "center",
	justifyContent: "center",
	p: 3
};

export default function SumbitFooter() {
	const { actions } = useContext(Context);
	const theme = useTheme();
	const { translate } = useLocales();
	return (
		<Stack
			sx={{
				...sx,
				borderColor: alpha(theme.palette.divider, 0.15)
			}}
		>
			<LoadingButton
				variant='outlined'
				startIcon={<Iconify icon='carbon:reset' />}
				color='inherit'
				onClick={actions.reset}
			>
				{translate("customization.reset")}
			</LoadingButton>
			<LoadingButton variant='contained' type='submit' sx={{ width: 150, ml: 4 }}>
				{translate("customization.save")}
			</LoadingButton>
		</Stack>
	);
}
